import React from 'react';
import { useAuth } from '../components/AuthProvider';
import MfaEnroll from '../components/MfaEnroll';

const Security: React.FC = () => {
  const { user } = useAuth();
  return <MfaEnroll email={user?.email ?? ''} onEnrolled={() => window.location.reload()} />;
};

export default Security;
